.wrapper {
  width: 100%;
}

.banner {
  width: 100%;
  margin: 0 auto;
}

.bannerImageWrapper {
  position: relative;
  width: 100%;
  max-height: 130px;
  overflow: hidden;
}

.bannerImage {
  display: block;
  width: 100%;
  object-fit: cover;
  --images-height: 130px;
}

.bannerImageSkeleton {
  min-height: 130px;
}
.bannerImagePlaceholder {
  height: 130px;
}

.searchBarWrapper {
  top: 36px;
}

@media (--view-sm) {
  .searchBarWrapper {
    top: 50%;
    transform: translateY(-50%);
  }
}

.searchBarContainer {
  max-width: 900px;
}

@media (--view-sm) {
  .searchBarContainer {
    padding: 12px 12px 12px 28px;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 auto;
  padding: 0 0 40px;
  width: 100%;
  max-width: var(--main-width);
}

.section {
  padding: 0 20px;
  .sectionHeading {
    margin-bottom: 24px;
    font-size: var(--font-size-4xl);
    font-weight: var(--font-weight-bold);
  }

  .sectionHeadingGradient {
    display: inline-block;
    font-size: var(--font-size-4xl);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-1);
  }
}

.hotDestinations {
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .item {
    display: block;
    flex: 0 0 160px;
    height: 200px;
    position: relative;
    overflow: hidden;
    border-radius: var(--border-radius-sm);
    background-size: cover;
    text-decoration: none;
    color: inherit;
    box-sizing: border-box;
    transition:
      transform 0.2s,
      box-shadow 0.2s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px var(--color-shadow-1);
    }
  }

  .itemCaption {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 12px 16px;
    color: var(--color-white);
    box-sizing: border-box;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      var(--color-overlay-bg) 100%
    );
  }

  .title {
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-semi-bold);
  }

  .description {
    font-size: var(--font-size-sm);
  }
}

@media (--view-sm) {
  .bannerImageWrapper {
    max-height: 400px;
  }
  .bannerImage {
    --images-height: 400px;
  }
  .bannerImageSkeleton {
    min-height: 400px;
  }
  .bannerImagePlaceholder {
    height: 400px;
  }
  .content {
    gap: 48px;
    padding: 40px 16px;
  }
  .section {
    padding: 0;
  }
  .hotDestinations .item {
    flex: 1;
  }
}
